module.exports = __webpack_public_path__ + "static/media/iconfont.ce197cf2.svg";